import { memoize } from 'lodash'
import { Ether } from 'types'
import { e2w, toFixed, w2e } from 'utils/number'

const memoizeDecimals = memoize(function (precision: string) {
  const ps = precision.split('.')
  return ps[1] ? ps[1].length : 0
})

const memoizePrecision = memoize(function (precision: string) {
  return e2w(precision)
})

/**
 * Convert the price to the specified precision
 *
 * @export
 * @param {Ether} price e.g. '2.342'
 * @param {string} precision e.g. '0.01'
 * @returns {Ether}
 */
export function precisionForPrice(price: Ether, precision: string): string {
  const decimals = memoizeDecimals(precision)
  if (decimals > 0) {
    return toFixed(price, decimals, {
      fixed: true,
    })
  }
  const _price = e2w(price)
  const remainder = _price.mod(memoizePrecision(precision))

  if (remainder.isZero()) {
    return price
  }
  return w2e(_price.sub(remainder))
}
